"use client";

import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MailOpen, TrendingUp, PenTool, Link as LinkIcon, Target } from "lucide-react";
const services = [{
  id: 1,
  icon: MailOpen,
  title: "Email List Building and Growth",
  teaser: "Expand your subscriber base with proven, restaurant-focused strategies that drive real growth."
}, {
  id: 2,
  icon: TrendingUp,
  title: "Data-Driven Campaign Strategy",
  teaser: "Leverage analytics and insights to craft campaigns that resonate with your diners."
}, {
  id: 3,
  icon: PenTool,
  title: "Copywriting and Content Creation",
  teaser: "Compelling, on-brand messaging that turns readers into loyal customers."
}, {
  id: 4,
  icon: LinkIcon,
  title: "System Integration",
  teaser: "Seamless connection with your reservation and POS systems for effortless execution."
}, {
  id: 5,
  icon: Target,
  title: "Campaign Management and Optimization",
  teaser: "Continuous monitoring and refinement to maximize ROI and repeat visits."
}];
export default function OurCoreServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="py-16 px-4 bg-background" ref={ref}>
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-12 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-4xl font-display font-bold text-foreground mb-3">
            Our Core Services
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            We specialize in helping restaurants build stronger connections with their customers through targeted email marketing.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: false,
        dragFree: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {services.map((service, i) => {
            const Icon = service.icon;
            return <CarouselItem key={service.id} data-index={i} className="pl-4 basis-full md:basis-1/2 lg:basis-1/3">
                  <Card className={`h-full border border-border shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
                transitionDelay: `${i * 100}ms`
              }}>
                    <CardHeader>
                      <div className="mb-4 inline-flex items-center justify-center w-14 h-14 rounded-lg bg-primary/10 text-primary transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:-translate-y-1">
                        <Icon className="w-7 h-7" />
                      </div>
                      <CardTitle className="text-xl text-foreground">
                        {service.title}
                      </CardTitle>
                      <CardDescription className="text-muted-foreground mt-2">
                        {service.teaser}
                      </CardDescription>
                    </CardHeader>
                    <CardContent>
                      <Link to="/ServicesPage" className="inline-flex items-center text-primary font-semibold hover:text-primary-hover transition-colors duration-[var(--duration-medium)] focus-ring">
                        Learn More
                        <svg className="w-4 h-4 ml-1 transition-transform duration-[var(--duration-medium)] group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </Link>
                    </CardContent>
                  </Card>
                </CarouselItem>;
          })}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex -left-12 hover:bg-primary hover:text-foreground-primary transition-colors duration-[var(--duration-medium)]" />
          <CarouselNext className="hidden md:flex -right-12 hover:bg-primary hover:text-foreground-primary transition-colors duration-[var(--duration-medium)]" />
        </Carousel>
      </div>
    </section>;
}